/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBudgetCost extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBudgetCost");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBudgetCost.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBudgetCost>): BackgroundJobPayloadForBudgetCost {
        let obj = Object.assign(new BackgroundJobPayloadForBudgetCost(), model);
        BackgroundJobPayloadForBudgetCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBudgetCost>): BackgroundJobPayloadForBudgetCost {
        if (!model) return null;
        return BackgroundJobPayloadForBudgetCost.newInstance(<BackgroundJobPayloadForBudgetCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBudgetCost) {
        if (!obj) return;

        models.BackgroundJobPayloadForBudgetCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBudgetCost): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBudgetCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of budget document
     */
    budget_id: string;

}
